import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { 
    ItemWrapper, 
    Label, 
    Input, 
    Container, 
    Button,
    Wrapper,
    Informative,
    TicketInfo,
    Description,
    Price, 
    ListWrapper
} from "./styles"
import client from "../../../../assets/service/client";
import { useQuery } from "react-query";

import { Bars } from "react-loader-spinner";

const CreatePromoForm = () => {
    const { id } = useParams();
    const [code, setCode] = useState("");
    const [limit, setLimit] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [activeTicketSpecs, setActiveTicketSpecs] = useState([])

    const onSubmit = async () => {
        if (!code) return;
        setLoading(true);

        await client.post("promo/new", {
            eventId: id,
            code: code.toLowerCase(),
            limit,
            ticketSpecIds: activeTicketSpecs
        })
        navigate(-1)
    }

    const checked = (event) => {
        const ticketSpecId = parseInt(event.target.value);
        const { checked } = event.target;
        if (checked) {
            setActiveTicketSpecs([...activeTicketSpecs, ticketSpecId])
        } else {
            setActiveTicketSpecs(activeTicketSpecs.filter(tid => tid != ticketSpecId))
        }
    }

    const getTicketSpecsByEventId = async () => {
        return await client.get(`/event/${id}/ticketSpecs`)
        .then(res => {
            return res.data.ticketSpecs;
        })
        .catch(err => err)
    }

    const { data: ticketSpecs } = useQuery('ticketSpecsByEventId', getTicketSpecsByEventId);

    return (
        <Container>
            <ItemWrapper>
                <Label>Código*</Label>
                <Input value={code} onChange={(event) => setCode(event.target.value.toLowerCase())} />
            </ItemWrapper>
            <ItemWrapper>
                <Label>Limite</Label>
                <Input value={limit ? limit : ""} onChange={(event) => setLimit(event.target.value)} />
            </ItemWrapper>
            <ListWrapper>
            {
            ticketSpecs && ticketSpecs.map(t => {
                    return (
                        <Wrapper key={t.id}>
                            <Informative>
                                <TicketInfo>
                                    <Description>{t.description}</Description>
                                    <Price>R${t.price}</Price>
                                </TicketInfo>
                                {
                                t.promo ? <span style={{fontSize: "0.75em", color: "gray"}}>cód. promo: <b>{t.promo}</b></span> :
                                <input type="checkbox" checked={activeTicketSpecs.includes(parseInt(t.id))} value={t.id} onChange={(event) => checked(event)}></input>
                                }
                            </Informative>
                        </Wrapper>
                    )
                })
            }
            <div style={{minHeight: '60px', height: 'calc(8% + 10px)'}} />
            </ListWrapper>
            { !loading ? <Button onClick={onSubmit}>Salvar</Button> : <Button><Bars
                                        height="30"
                                        width="30"
                                        color="white"
                                        ariaLabel="bars-loading"
                                        wrapperStyle={{width: "100%", display: 'flex', 'alignItems': 'center', 'justifyContent': 'center'}}
                                        wrapperClass=""
                                        visible={true}
                                    /></Button>
        }
        </Container>
        )
}

export default CreatePromoForm